import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=135f7808"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135f7808')) {
      api.createRecord('135f7808', component.options)
    } else {
      api.reload('135f7808', component.options)
    }
    module.hot.accept("./applications.vue?vue&type=template&id=135f7808", function () {
      api.rerender('135f7808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/applications.vue"
export default component.exports